(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gjl-home-clips"] && !Shopify.designMode) return;
  try {
    
  // Native, manual playback only. Do not leave a hidden film playing.
  document.addEventListener('play', (event) => {
    const playing = event.target;
    if (!(playing instanceof HTMLVideoElement) || !playing.closest('.gjl-film')) return;
    document.querySelectorAll('.gjl-film video').forEach((video) => {
      if (video !== playing) video.pause();
    });
  }, true);
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.matches('.gjl-film__more') || details.open) return;
    details.querySelectorAll('video').forEach((video) => video.pause());
  }, true);
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.gjl-film video').forEach((video) => video.pause());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gjl-review-invitation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gjl-review-invitation')) {
    class GjlReviewInvitation extends HTMLElement {
      constructor() {
        super();
        this.onWriteClick = this.onWriteClick.bind(this);
        this.onDetailsToggle = this.onDetailsToggle.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
        this.onHashChange = this.onHashChange.bind(this);
      }

      connectedCallback() {
        this.details = this.querySelector('.gjl-review-invitation__details');
        this.widgetContainer = this.querySelector('.gjl-review-invitation__widget');
        this.writeButton = this.querySelector('.gjl-review-invitation__write');
        this.summary = this.querySelector('.gjl-review-invitation__summary');
        if (!this.details || !this.widgetContainer || !this.writeButton) return;
        this.writeButton.addEventListener('click', this.onWriteClick);
        this.details.addEventListener('toggle', this.onDetailsToggle);
        document.addEventListener('click', this.onDocumentClick, true);
        document.addEventListener('keydown', this.onDocumentKeydown, true);
        document.addEventListener('keyup', this.onDocumentKeydown, true);
        window.addEventListener('hashchange', this.onHashChange);
        this.startWidgetWait();
        this.onHashChange();
      }

      disconnectedCallback() {
        this.writeButton?.removeEventListener('click', this.onWriteClick);
        this.details?.removeEventListener('toggle', this.onDetailsToggle);
        document.removeEventListener('click', this.onDocumentClick, true);
        document.removeEventListener('keydown', this.onDocumentKeydown, true);
        document.removeEventListener('keyup', this.onDocumentKeydown, true);
        window.removeEventListener('hashchange', this.onHashChange);
        this.stopWidgetWait();
        this.stopModalWatch();
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.focusFrame);
      }

      getNativeWriteButton() {
        const button = this.widgetContainer.querySelector('#judgeme_product_reviews [data-testid="write-review-button"]');
        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return null;
        return button;
      }

      syncWriteButton() {
        const button = this.getNativeWriteButton();
        this.writeButton.hidden = !button;
        this.writeButton.disabled = !button;
        if (!button) return false;
        this.dataset.reviewReady = 'true';
        this.stopWidgetWait();
        return true;
      }

      startWidgetWait() {
        this.stopWidgetWait();
        if (this.syncWriteButton()) return;
        this.dataset.reviewReady = 'waiting';
        this.widgetObserver = new MutationObserver(() => this.syncWriteButton());
        this.widgetObserver.observe(this.widgetContainer, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled']
        });
        this.widgetTimer = setTimeout(() => {
          this.stopWidgetWait();
          if (!this.syncWriteButton()) this.dataset.reviewReady = 'fallback';
        }, 15000);
      }

      stopWidgetWait() {
        this.widgetObserver?.disconnect();
        this.widgetObserver = null;
        clearTimeout(this.widgetTimer);
        this.widgetTimer = null;
      }

      onDetailsToggle() {
        if (this.details.open) this.startWidgetWait();
      }

      isCurrentProductTrigger(element) {
        const badge = element.closest('.jdgm-prev-badge');
        if (!badge) return false;
        const badgeProductId = badge.getAttribute('data-id') || badge.getAttribute('data-product-id');
        if (badgeProductId) return badgeProductId === this.dataset.productId;
        return !!badge.closest('.product__info-container');
      }

      onDocumentClick(event) {
        if (!(event.target instanceof Element)) return;
        const stars = event.target.closest('.jdgm-prev-badge__stars[role="button"]');
        if (stars && this.isCurrentProductTrigger(stars)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.openReviews();
          return;
        }
        const link = event.target.closest('a[href]');
        if (!link) return;
        let url;
        try {
          url = new URL(link.getAttribute('href'), window.location.href);
        } catch {
          return;
        }
        if (url.origin === window.location.origin && url.pathname === window.location.pathname && url.hash === '#judgeme_product_reviews') {
          this.openReviews();
        }
      }

      onDocumentKeydown(event) {
        if ((event.key !== 'Enter' && event.key !== ' ') || !(event.target instanceof Element)) return;
        const stars = event.target.closest('.jdgm-prev-badge__stars[role="button"]');
        if (!stars || !this.isCurrentProductTrigger(stars)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.openReviews();
      }

      onHashChange() {
        if (window.location.hash === '#judgeme_product_reviews') this.openReviews();
      }

      openReviews() {
        this.details.open = true;
        this.startWidgetWait();
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          const target = this.widgetContainer.querySelector('#judgeme_product_reviews') || this.details;
          target.scrollIntoView({
            block: 'start',
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        });
      }

      onWriteClick() {
        const nativeButton = this.getNativeWriteButton();
        if (!nativeButton) {
          this.writeButton.hidden = true;
          this.writeButton.disabled = true;
          this.openReviews();
          return;
        }
        this.startModalWatch();
        nativeButton.click();
        this.checkModalState();
      }

      isModalVisible(modal) {
        if (!modal?.isConnected || modal.hidden || modal.getAttribute('aria-hidden') === 'true') return false;
        const style = getComputedStyle(modal);
        return style.display !== 'none' && style.visibility !== 'hidden';
      }

      startModalWatch() {
        this.stopModalWatch();
        this.modalHasOpened = false;
        this.modal = Array.from(document.body.children).find(node => node.matches('.jdgm-write-review-modal')) || null;
        this.modalBodyObserver = new MutationObserver(records => {
          if (!this.modal || !this.modal.isConnected) {
            for (const record of records) {
              for (const node of record.addedNodes) {
                if (node instanceof Element && node.matches('.jdgm-write-review-modal')) {
                  this.attachModal(node);
                  break;
                }
              }
            }
          }
          this.checkModalState();
        });
        this.modalBodyObserver.observe(document.body, { childList: true });
        if (this.modal) this.attachModal(this.modal);
        this.modalTimer = setTimeout(() => this.stopModalWatch(), 10000);
      }

      attachModal(modal) {
        this.modalObserver?.disconnect();
        this.modal = modal;
        this.modalObserver = new MutationObserver(() => this.checkModalState());
        this.modalObserver.observe(modal, {
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'data-state']
        });
      }

      checkModalState() {
        if (this.isModalVisible(this.modal)) {
          if (!this.modalHasOpened) {
            this.modalHasOpened = true;
            clearTimeout(this.modalTimer);
            this.modalTimer = setTimeout(() => this.stopModalWatch(), 600000);
          }
          return;
        }
        if (!this.modalHasOpened) return;
        this.stopModalWatch();
        cancelAnimationFrame(this.focusFrame);
        this.focusFrame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          const target = this.writeButton.hidden ? this.summary : this.writeButton;
          target?.focus({ preventScroll: true });
        });
      }

      stopModalWatch() {
        this.modalObserver?.disconnect();
        this.modalBodyObserver?.disconnect();
        this.modalObserver = null;
        this.modalBodyObserver = null;
        clearTimeout(this.modalTimer);
        this.modalTimer = null;
        this.modal = null;
        this.modalHasOpened = false;
      }
    }

    customElements.define('gjl-review-invitation', GjlReviewInvitation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
